import React, { useEffect, useMemo, useState } from "react";
import {
  Grid,
  TextField,
  Box,
  MenuItem,
  Chip,
  InputLabel,
  Select,
  OutlinedInput,
  FormControl,
  Typography,
  Checkbox,
  List,
  ListItem,
  ListItemText,
  InputAdornment,
  IconButton,
  Autocomplete,
} from "@mui/material";
import { useFormik } from "formik";
import * as Yup from "yup";
import PlacesAutocomplete from "react-places-autocomplete";
import "./style.css";
import {
  convertToGMT,
  convertToUTC,
  extractSuggestionProps,
  getMinDateTime,
  handleRedirectUrl,
  roundToNext5Minutes,
} from "../../utils/Functions";
import moment from "moment";
import { Link, useLocation, useParams } from "react-router-dom";
import Loader from "../loader";
import {
  getRidePostByData,
  postSaveRidePosts,
  postUpdateRidePosts,
} from "../../utils/api.functions";
import { toast } from "react-toastify";
import citiesJson from "../../utils/cities";
import { defaultValues, delayData } from "../../utils/common.data";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { DateTimePicker } from "@mui/x-date-pickers/DateTimePicker";
import dayjs from "dayjs";

const stepValidationSchemas = [
  // Step 0: General Info
  Yup.object({
    from_location: Yup.string().trim().required("This field is Required"),
    to_location: Yup.string()
      .trim()
      .required("This field is Required")
      .test(
        "different-from-start",
        "End location cannot be the same as start location",
        function (value) {
          const { from_location } = this.parent;
          return value !== from_location;
        }
      ),
  }),
  // Step 1: Select Departure Date
  Yup.object({
    departure_date: Yup.string().required("This field is Required"),
    seats: Yup.number().required("This field is Required").min(1),
  }),
];

const validationSchema = Yup.object({
  from_location: Yup.string().trim().required("This field is Required"),
  to_location: Yup.string()
    .trim()
    .required("This field is Required")
    .test(
      "different-from-start",
      "End location cannot be the same as start location",
      function (value) {
        const { from_location } = this.parent;
        return value !== from_location;
      }
    ),
  departure_date: Yup.string().required("This field is Required"),
  seats: Yup.number().required("This field is Required").min(1),
});

const PostRequestForm = ({ handleBack }) => {
  const [formView, setFormView] = useState(0);
  const [isLoading, setIsLoading] = useState(false);
  const [ridePostData, setRidePostData] = useState([]);
  const params = useParams();

  const initialFormValues = useMemo(
    () => ({
      from_location: "",
      to_location: "",
      departure_date: roundToNext5Minutes(dayjs().add(1, "hour")),
      seats: "1",
    }),
    []
  );

  const formik = useFormik({
    initialValues: initialFormValues,
    validationSchema: validationSchema,
    onSubmit: (values) => {
      const payload = {
        ...values,
      };
      //   console.log("Form submitted:", payload);

      const createData = {
        ...payload,
        from_location: payload.from_location,
        to_location: payload.to_location,
        departure_date: moment(convertToGMT(payload.departure_date)).format(
          "YYYY-MM-DD HH:mm:ss"
        ),
      };
      if (createData?.pickup) {
        delete createData.pickup;
      }
      if (createData?.drop) {
        delete createData.drop;
      }
      //   console.log({ createData })

      if (params?.id) {
        handleUpdate(params?.id, createData);
      } else {
        handleCreate(createData);
      }
    },
  });

  useEffect(() => {
    getPostRideData();
  }, []);

  // Params Data

  const location = useLocation();

  useEffect(() => {
    const mainValue = new URLSearchParams(location.search);
    const value = mainValue.get("params");
    //console.log({value})
    if (value) {
      try {
        const testdata = JSON.parse(value);
        // console.log({testdata})
        sessionStorage.setItem("key", testdata?.key);
        sessionStorage.setItem("code", testdata?.c_code);
        sessionStorage.setItem(
          "phone",
          "+" + testdata?.c_code + "" + testdata?.phone
        );
        sessionStorage.setItem("userid", testdata?.userid);
        sessionStorage.setItem("company_id", testdata?.comp_id);
        sessionStorage.setItem("fname", testdata?.fname);
        sessionStorage.setItem("lname", testdata?.lname);
        sessionStorage.setItem("email", testdata?.email);
        sessionStorage.setItem("name", testdata?.name);
        sessionStorage.setItem("city_id", testdata?.city_id);
        sessionStorage.setItem("city_cur", testdata?.city_cur);
        sessionStorage.setItem("auth", JSON.stringify(testdata));
      } catch (error) {
        console.log(`User Params Data`, error?.message);
        handleRedirectUrl(process.env.REACT_APP_TRIP_FAIL_API, "_self");
      }
    } else {
      handleRedirectUrl(process.env.REACT_APP_TRIP_FAIL_API, "_self");
    }
  }, []);

  const handleCreate = async (data) => {
    setIsLoading(true);
    const apikey = sessionStorage.getItem("key");
    const userid = sessionStorage.getItem("userid");
    const city_id = sessionStorage.getItem("city_id");
    try {
      const ridePostData = {
        ...data,
        user_id: userid,
        city_id: city_id,
      };

      const ridePostReponse = await postSaveRidePosts(ridePostData, apikey);
      if (ridePostReponse.status == 200) {
        toast.success("Ride Request Created Successfully");
        setIsLoading(false);
        sessionStorage.removeItem("searchdetails");
        // setTimeout(() => {
        //   handleRedirectUrl(
        //     `${
        //       process.env.REACT_APP_TRIP_SUCCESS_API
        //     }?requestData=${JSON.stringify(
        //       ridePostReponse.data.resDecrypt.response
        //     )}`,
        //     "_self"
        //   );
        // }, delayData.androidFormDelay);
        handleRedirectUrl(
          `${
            process.env.REACT_APP_TRIP_SUCCESS_API
          }?requestData=${JSON.stringify(
            ridePostReponse.data.resDecrypt.response
          )}`,
          "_self"
        );
      }
    } catch (error) {
      toast.dismiss();
      console.log(`Ride Request Posts Error`, error);
      toast.error(
        error?.response?.data?.resDecrypt?.message ||
          error?.message ||
          "Something Went Wrong?"
      );
      setIsLoading(false);
      // setTimeout(() => {
      //   handleRedirectUrl(
      //     `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
      //     "_self"
      //   );
      // }, delayData.androidFormDelay);
    }
  };

  const handleUpdate = async (id, data) => {
    setIsLoading(true);
    const apikey = sessionStorage.getItem("key");
    const userid = sessionStorage.getItem("userid");
    const city_id = sessionStorage.getItem("city_id");
    try {
      const ridePostData = {
        ...data,
        id: id,
        user_id: userid,
        city_id: city_id,
      };
      // console.log(ridePostData);

      const ridePostReponse = await postUpdateRidePosts(ridePostData, apikey);
      if (ridePostReponse.status == 200) {
        toast.success("Ride Request Updated Successfully");
        setIsLoading(false);
        sessionStorage.removeItem("searchdetails");
        // if (handleBack) {
        //   handleBack();
        //   return
        // }
        handleRedirectUrl(
          `${
            process.env.REACT_APP_TRIP_SUCCESS_API
          }?requestData=${JSON.stringify(
            ridePostReponse?.data?.resDecrypt?.response
          )}`,
          "_self"
        );
      }
    } catch (error) {
      toast.dismiss();
      console.log(`Ride Request Posts Error`, error);
      toast.error(
        error?.response?.data?.resDecrypt?.message ||
          error?.message ||
          "Something Went Wrong?"
      );
      setIsLoading(false);
      // handleRedirectUrl(
      //   `${process.env.REACT_APP_TRIP_FAIL_API}?requestData=${error?.message}`,
      //   "_self"
      // );
    }
  };

  const getPostRideData = async () => {
    if (params?.id) {
      setIsLoading(true);
      let apikey = sessionStorage.getItem("key");
      const userid = sessionStorage.getItem("userid");
      try {
        const response = await getRidePostByData(
          { ride_id: params?.id, city_id: 1 },
          apikey
        );
        ////console.log({ response });

        if (response.status === 200) {
          const newData = response?.data?.resDecrypt?.response;

          if (newData && newData.length > 0) {
            setRidePostData(newData);
            formik.setFieldValue("from_location", newData[0]?.from_location);
            formik.setFieldValue("to_location", newData[0]?.to_location);
            formik.setFieldValue("seats", newData[0]?.seats);
            formik.setFieldValue(
              "departure_date",
              moment(convertToUTC(newData[0]?.departure_date)).format(
                "YYYY-MM-DDTHH:mm"
              )
            );
            setIsLoading(false);
          } else {
            setIsLoading(false); // Disable loading if no data
          }
        } else {
          setIsLoading(false);
        }
      } catch (error) {
        toast.dismiss();
        console.log(`Ride Request Posts Error`, error);
        toast.error(
          error?.response?.data?.resDecrypt?.message ||
            error?.message ||
            "Something Went Wrong?"
        );
        setIsLoading(false);
      }
    }
  };

  const handleFormviewChange = async (val) => {
    const errors = await formik.validateForm();
    if (Object.keys(errors).length === 0) {
      if (formView + val == 2) {
        await formik.submitForm();
      } else {
        setFormView((prev) => prev + val);
      }
    } else {
      formik.setTouched(
        Object.keys(errors).reduce((acc, key) => {
          acc[key] = true;
          return acc;
        }, {}),
        false
      );
    }
  };

  const handleFormViewBack = (val) => {
    const viewCheck = formView - val;
    if (viewCheck < 0) {
      setFormView(0);
      try {
        if (window.AndroidFunction) {
          console.log("Android");
          window.AndroidFunction.postMessage("Finish");
        } else {
          console.log("No Interface available");
        }

        const eventDetail = { message: "Finish", timestamp: Date.now() };
        // Create and dispatch the event
        const event = new CustomEvent("iosCustomEvent", {
          detail: eventDetail,
        });
        document.dispatchEvent(event);
        console.log("Custom event dispatched", eventDetail);
      } catch (error) {
        console.log(`No Interface available Err`, error);
      }
      return;
    }
    setFormView((prev) => prev - val);
  };

  const handleSortCity = (value) => {
    return value.sort((a, b) => a.name.localeCompare(b.name));
  };
  const uniqueCities = useMemo(() => {
    const seen = new Set();
    return handleSortCity(citiesJson).filter((city) => {
      if (seen.has(city.name)) return false;
      seen.add(city.name);
      return true;
    });
  }, [citiesJson]);

  const incrementSeat = (step) => {
    // console.log({ step }, parseInt(formik.values.seats) + step);
    formik.setFieldValue(
      "seats",
      parseInt(!formik.values.seats ? 0 : formik.values.seats) + step
    );
  };

  const decrementSeat = (step) => {
    // console.log({ step }, parseInt(formik.values.seats) - step);
    formik.setFieldValue("seats", parseInt(formik.values.seats) - step);
  };

  return (
    <form onSubmit={formik.handleSubmit}>
      <section className="post_request_form_mobile_container">
        <aside
          className="post_request_form_mobile_container_close"
          onClick={() => {
            handleFormViewBack(1);
          }}
        >
          {/* {formView == 0 ? (
            <i className="fas fa-times"></i>
          ) : (
            <i className="fas fa-arrow-left"></i>
          )} */}
          <i className="fas fa-arrow-left"></i>
          <Typography
            variant="h4"
            className="post_request_heading"
            gutterBottom
            sx={{ textAlign: "center" }}
          >
            Post Request
          </Typography>
        </aside>
        {/* {formView !== 2 && (
        <aside
          className="post_request_form_mobile_container_arrow"
          onClick={() => {
            handleFormviewChange(1);
          }}
        >
          <i className="fas fa-arrow-right"></i>
        </aside>
      )} */}
        {isLoading && <Loader classValue="loader_container_main" />}
        <Typography
          variant="h6"
          mt={2}
          mb={2}
          className="post_request_heading_title post_request_form_mobile_container_title"
        >
          Select Location
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={uniqueCities}
              getOptionLabel={(option) => {
                return option.name ?? "";
              }}
              value={
                uniqueCities.find(
                  (city) => city.name === formik.values.from_location
                ) || null
              }
              onChange={(event, newValue) => {
                formik.setFieldValue("from_location", newValue?.name || null);
              }}
              filterOptions={(options, { inputValue }) =>
                options.filter((option) =>
                  option.name.toLowerCase().includes(inputValue.toLowerCase())
                )
              }
              renderInput={(params) => (
                <TextField
                  key={params.id}
                  {...params}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  label="From"
                  placeholder="Enter From Location"
                  error={
                    formik.touched.from_location &&
                    Boolean(formik.errors.from_location)
                  }
                  helperText={
                    formik.touched.from_location && formik.errors.from_location
                  }
                />
              )}
              isOptionEqualToValue={(option, value) => {
                // console.log({option},value)
                return option.name === value;
              }}
            />

            {formik.touched.from_location && formik.errors.from_location && (
              <Typography color="error" variant="caption">
                {formik.errors.from_location}
              </Typography>
            )}
          </Grid>
          <Grid item xs={12} sm={6}>
            <Autocomplete
              options={uniqueCities}
              getOptionLabel={(option) => {
                return option.name ?? "";
              }}
              value={
                uniqueCities.find(
                  (city) => city.name === formik.values.to_location
                ) || null
              }
              onChange={(event, newValue) => {
                formik.setFieldValue("to_location", newValue?.name || null);
              }}
              filterOptions={(options, { inputValue }) =>
                options.filter((option) =>
                  option.name.toLowerCase().includes(inputValue.toLowerCase())
                )
              }
              renderInput={(params) => (
                <TextField
                  key={params.id}
                  {...params}
                  fullWidth
                  InputLabelProps={{ shrink: true }}
                  label="To"
                  placeholder="Enter To Location"
                  error={
                    formik.touched.to_location &&
                    Boolean(formik.errors.to_location)
                  }
                  helperText={
                    formik.touched.to_location && formik.errors.to_location
                  }
                />
              )}
              isOptionEqualToValue={(option, value) => {
                return option.name === value;
              }}
            />

            {formik.touched.to_location && formik.errors.to_location && (
              <Typography color="error" variant="caption">
                {formik.errors.to_location}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Typography
          variant="h6"
          mt={2}
          mb={2}
          className="post_request_heading_title post_request_form_mobile_container_title"
        >
          Select Departure
        </Typography>

        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <LocalizationProvider dateAdapter={AdapterDayjs}>
              <DateTimePicker
                value={formik.values.departure_date}
                minDate={dayjs().add(1, "hour")}
                minTime={dayjs().add(1, "hour")}
                disablePast
                ampm
                onChange={(e) => {
                  formik.setFieldValue("departure_date", e);
                }}
                format="YYYY-MM-DD hh:mm A"
                label="Departure Date"
                slotProps={{
                  textField: {
                    error: false,
                    // inputProps: {
                    //   disabled: true,
                    // },
                  },
                }}
              />
            </LocalizationProvider>
            {formik.touched.departure_date && formik.errors.departure_date && (
              <Typography color="error" variant="caption">
                {formik.errors.departure_date}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Typography
          variant="h6"
          mt={2}
          mb={2}
          className="post_request_heading_title post_request_form_mobile_container_title"
        >
          Select Seats
        </Typography>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6}>
            <div className="post_request_form_mobile_container_seat">
              <button
                type="button"
                onClick={() => {
                  decrementSeat(defaultValues.seatStep);
                }}
                disabled={formik.values.seats <= defaultValues.minSeat}
              >
                <i className="fas fa-minus"></i>
              </button>
              {/* <span>{formik.values.seats}</span> */}
              <input
                type="number"
                name="seats"
                value={formik.values.seats}
                onChange={(e) => {
                  const newValue = parseInt(e.target.value, 10);
                  if (!isNaN(newValue)) {
                    if (
                      newValue >= defaultValues.minSeat &&
                      newValue <= defaultValues.maxSeat
                    ) {
                      formik.setFieldValue("seats", newValue);
                    }
                  } else {
                    formik.setFieldValue("seats", "");
                  }
                }}
                onBlur={(e) => {
                  formik.handleBlur(e);
                  if (!formik.values.seats) {
                    formik.setFieldValue("seats", defaultValues.minSeat);
                  }
                }}
                className="post_request_form_mobile_container_seat_input_field"
              />
              <button
                type="button"
                onClick={() => {
                  incrementSeat(defaultValues.seatStep);
                }}
                disabled={formik.values.seats == defaultValues.maxSeat}
              >
                <i className="fas fa-plus"></i>
              </button>
            </div>

            {formik.touched.seats && formik.errors.seats && (
              <Typography color="error" variant="caption">
                {formik.errors.seats}
              </Typography>
            )}
          </Grid>
        </Grid>
        <Box mt={2} mb={2}>
          <button
            type="submit"
            className="post_request_mobile_button common_booking_button common_button_border"
          >
            Post{" "}
            <i className="fas fa-arrow-circle-right" aria-hidden="true"></i>
          </button>
        </Box>
      </section>
    </form>
  );
};

export default PostRequestForm;
